/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as Logo } from "../assets/icons/logo-dark.svg";
import { ReactComponent as Arrow } from "../assets/icons/arrow-down.svg";
import Button from "../components/ui/button";

type PropType = {
  onClose: () => void;
};
const SideMenu = ({ onClose }: PropType) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const onHideMenu = (route?: string) => {
    setTimeout(() => {
      setMenuOpen(false);

      if (route) navigate(route);
      onClose();
    }, 300);
  };

  const navigationLinks = [
    {
      page: "product",
      to: "/product",
      text: "product",
      subNav: [
        {
          to: "/money-transfer",
          text: "Send & Receive Money",
        },
        {
          to: "/virtual-card",
          text: "Virtual Dollar Card",
        },
        {
          to: "/virtual-wallet",
          text: "Virtual Wallet",
        },
        {
          to: "#",
          text: "Pay Bills",
        },
        // {
        //   to: "https://kudihero.com/",
        //   text: "Kudi Hero",
        // },

        // {
        //   to: "#",
        //   text: "Agency Program",
        // },
        // {
        //   to: "/business",
        //   text: "FX Kudi For Business",
        // },
      ],
    },
    {
      page: "company",
      to: "/about",
      text: "company",
    },
    {
      page: "blog",
      to: "https://fxkudiblog.com/",
      text: "blog",
    },
    {
      page: "contact",
      to: "/contact",
      text: "contact",
    },
  ];
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div
      // onClick={() => {
      //   onHideMenu();
      // }}
      className="bg-lightBlack z-[20] fixed top-0 left-0 right-0 bottom-0 transition-all ease-in-out delay-150"
    >
      <div className="flex flex-col justify-between w-[75%] nav bg-[#FFFDF6] fixed top-0 bottom-0 pb-20 p-6 z-[19] ">
        <div className="">
          <Link to="/" className="">
            <Logo className="w-24" />
          </Link>
          <div className="flex flex-col mt-10 gap-4">
            {navigationLinks.map((item, index) => (
              <div className="uppercase">
                {item.page === "blog" ? (
                  <a href={item.to} target="_blank" rel="noreferrer">
                    {item.text}
                  </a>
                ) : (
                  <div
                    className={`cursor-pointer flex items-center justify-between`}
                    onClick={() => {
                      item.text === "product"
                        ? setIsOpen(!isOpen)
                        : onHideMenu(`${item.to}`);
                    }}
                  >
                    {item.text}{" "}
                    {item.subNav && (
                      <Arrow
                        className={`${!isOpen ? "" : "rotate-180"}`}
                        stroke="black"
                      />
                    )}
                  </div>
                )}
                {isOpen && item.subNav && (
                  <div className="pl-5 capitalize flex flex-col gap-3 py-3 ">
                    {item.subNav.map((it) => (
                      <div className="text-sm font-normal">
                        {it.text === "Kudi Hero" ? (
                          <a
                            href={it.to}
                            target="_blank"
                            rel="noreferrer"
                            className="flex items-center justify-between"
                          >
                            {it.text}
                          </a>
                        ) : (
                          <Link
                            to={it.to}
                            className="flex items-center justify-between"
                          >
                            {it.text}
                          </Link>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              // <div
              //   className="uppercase"
              //   key={index}
              //   onClick={() => onHideMenu(`${item.to}`)}
              // >
              //   {item.text}
              // </div>
            ))}
          </div>
        </div>
        <Button
          backgroundColor="#C29500"
          label="Become an Agent"
          loading={false}
          onClick={() => {}}
          type="contained"
          color="white"
          rounded
        />
      </div>
      <div
        className="fixed top-0 bottom-0 right-0 w-[25%] z-[19]"
        onClick={onClose}
      ></div>
    </div>
  );
};

export default SideMenu;
